module.exports = __webpack_public_path__ + "img/patricia-ava.0c40484.png";